// FAQ accordion — each question toggles its own answer independently (no
// auto-closing others), all closed by default. See sections/nosh-faq-list.liquid.
//
// The FAQ page uses more than one nosh-faq-list section instance (one per
// group of questions), so this script tag is included once per instance —
// without the guard below, each click bound twice and toggled straight back
// closed again.
(function () {
  function initAccordion() {
    document.querySelectorAll(".faq-question").forEach(function (btn) {
      var answer = btn.nextElementSibling;
      if (!answer || !answer.classList.contains("faq-answer")) return;
      btn.addEventListener("click", function () {
        var isOpen = btn.classList.toggle("nosh-active");
        btn.setAttribute("aria-expanded", String(isOpen));
        answer.classList.toggle("visible", isOpen);
      });
    });
  }

  // Sidebar rail: smooth-scroll on click, highlight whichever group is
  // currently in view on scroll. No-ops harmlessly if the rail markup
  // isn't present (e.g. an older cached section render).
  function initRail() {
    var links = Array.prototype.slice.call(document.querySelectorAll(".faq-rail__link"));
    if (!links.length) return;
    var groups = links.map(function (a) {
      return document.getElementById(decodeURIComponent(a.getAttribute("href").slice(1)));
    });

    links.forEach(function (a, i) {
      a.addEventListener("click", function (e) {
        e.preventDefault();
        var target = groups[i];
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

    if (!("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var idx = groups.indexOf(entry.target);
        if (idx === -1) return;
        links.forEach(function (a) { a.classList.remove("is-active"); });
        links[idx].classList.add("is-active");
      });
    }, { rootMargin: "-20% 0px -70% 0px" });
    groups.forEach(function (g) { if (g) observer.observe(g); });
  }

  function init() {
    if (window.noshFaqBound) return;
    window.noshFaqBound = true;
    initAccordion();
    initRail();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
